/* eslint-disable */
import config from '../../config'
import { useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import Breadcrumb from '../../components/core/breadcrumb'
import PageTitle from '../../components/core/pageTitle'
import { Button } from '../../components/core/button'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'

const BussinesConsulting = ({ className }) => {
  const { language } = useContext(PageContext)
  const DEFAULT_DATA = {
    title: {
      AZ: 'Biznes Konsaltinq Xidmətləri',
      ENG: 'Business Consulting Services',
      RU: 'Услуги бизнес-консалтинга',
      TR: 'İş Danışmanlığı Hizmetleri',
    },
    description_az: '<p>Biznesinizin mövcud vəziyyətini qiymətləndirir, əsas problemləri və inkişaf imkanlarını müəyyənləşdirir, maliyyə, vergi, HR, hüquq və biznes prosesləri üzrə ehtiyaclarınıza uyğun kompleks həllər formalaşdırırıq.</p>',
    description_eng: '<p>We assess the current state of your business, identify key challenges and development opportunities, and formulate comprehensive solutions tailored to your needs across finance, tax, HR, legal, and business processes.</p>',
    description_ru: '<p>Мы оцениваем текущее состояние вашего бизнеса, выявляем ключевые проблемы и возможности для роста, формируя комплексные решения в области финансов, налогов, HR, права и бизнес-процессов.</p>',
    description_tr: '<p>İşletmenizin mevcut durumunu değerlendiriyor, temel sorunları ve gelişim fırsatlarını tespit ediyor; finans, vergi, İK, hukuk ve iş süreçlerinde ihtiyaçlarınıza özel bütüncül çözümler geliştiriyoruz.</p>',
  }
  const [load, setLoad] = useState(true)
  const [data, setData] = useState(DEFAULT_DATA)
  useEffect(() => {
    (async () => {
      try {
        const res = await PagesAPI.getBussinesCunsultingPage()
        if (res?.data && res.data.title) {
          setData(res.data)
        }
      } catch (e) {
        console.warn('Using default Business Consulting page data')
      }
    })()
  }, [])
  const linkBuilder = (url) => {
    if (!url) return ''
    if (url.startsWith('http://') || url.startsWith('https://')) return url
    return `${config.API_URL}${url.startsWith('/') ? '' : '/'}${url}`
  }
  const crumbs = [
    {
      link: '/',
      text: {
        AZ: 'Ana Səhifə',
        ENG: 'Home',
        RU: 'Главная страница',
        TR: 'Ana Sayfa',
      },
    },
    {
      link: '#',
      text: {
        AZ: 'Biznes Konsaltinq Xidmətləri',
        ENG: 'Business Consulting Services',
        RU: 'Услуги бизнес-консалтинга',
        TR: 'İş Danışmanlığı Hizmetleri',
      },
    },
  ]
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <div>
        <Breadcrumb crumbs={crumbs} />
        <PageTitle>{data?.title?.[language] || data?.title?.TR || data?.title?.AZ || ''}</PageTitle>
        <p
          dangerouslySetInnerHTML={{
            __html:
              language === 'AZ'
                ? data?.description_az
                : language === 'TR'
                ? (data?.description_tr || data?.description_az)
                : language === 'ENG'
                ? data?.description_eng
                : (data?.description_ru || data?.description_az),
          }}
        />
        <figure
          style={{
            backgroundImage: `url('${linkBuilder(data?.photoLocation)}')`,
          }}
        />
        <div style={{ marginTop: '36px', display: 'flex', justifyContent: 'center' }}>
          <Button to={'/get-service1'}>
            {language === 'AZ' ? 'Xidmət Sifariş Edin →' : language === 'TR' ? 'Hizmet Talep Edin →' : language === 'ENG' ? 'Request Service →' : 'Заказать услугу →'}
          </Button>
        </div>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default BussinesConsulting
